import React from "react";
import { IoIosWallet, IoIosArrowForward, IoIosTime } from "react-icons/io";
import { FormatNumber } from "../../helpers";

export default function WalletCardEdit({
  data,
  onClick,
  inactive = false,
  lastUsedLabel,
}) {
  const sum = data.sum || 0;
  const isNegative = sum < 0;
  const isZero = sum === 0;

  return (
    <li
      className={`wallet-card ${isNegative ? "wallet-card--negative" : ""} ${
        inactive ? "wallet-card--inactive" : ""
      }`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick(e)}
    >
      <span className="wallet-card__rail" aria-hidden />
      <span className="wallet-card__icon">
        <IoIosWallet />
      </span>
      <div className="wallet-card__body">
        <div className="wallet-card__name">{data.name}</div>
        {inactive && lastUsedLabel ? (
          <div className="wallet-card__desc wallet-card__last-used">
            <IoIosTime /> {lastUsedLabel}
          </div>
        ) : (
          data.description && (
            <div className="wallet-card__desc">{data.description}</div>
          )
        )}
      </div>
      <div className="wallet-card__right">
        <div
          className={`wallet-card__amount ${
            isZero ? "wallet-card__amount--zero" : ""
          }`}
        >
          {isNegative ? "−" : ""}Rp{" "}
          {FormatNumber(Math.abs(Math.round(sum)))}
        </div>
        <IoIosArrowForward className="wallet-card__chev" />
      </div>
    </li>
  );
}
